import React from "react";
import Slider from "react-slick";

const Testimonialsabout = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section
      className="testimonial pt-9"
      style={{ backgroundImage: "url(images/testimonial.png)" }}
    >
      <div className="container">
        <div className="section-title mb-6 text-center w-75 mx-auto">
          <h4 className="mb-1 theme1">Testimonials</h4>
          <h2 className="mb-1">
            Experiences at <span className="theme">Anand Krushi Parytan Kendra</span>
          </h2>
          <p>
            Discover what our visitors say about their unique agro-tourism experiences with us.
          </p>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-5 pe-4">
            <div className="testimonial-image">
              <img src="images/travel2.png" alt="Agro Tourism" />
            </div>
          </div>
          <div className="col-lg-7 ps-4">
            <Slider {...settings}>
              <div className="item">
                <div className="testimonial-item1 rounded">
                  <div className="author-info mt-2 d-flex align-items-center mb-4">
                    <a href="#">
                      {/* <img
                        src="images/testimonial/visitor1.jpg"
                        alt="Visitor"
                      /> */}
                    </a>
                    <div className="author-title ms-3">
                      <h5 className="m-0 theme">Miss. Priya Deshmukh</h5>
                      <span>Travel Blogger</span>
                    </div>
                  </div>
                  <div className="details">
                    <p className="m-0">
                      <i className="fa fa-quote-left me-2 fs-1"></i>
                      Anand Krushi Parytan Kendra offers a serene and educational
                      escape into rural life. The farm stay, organic meals, and
                      warm hospitality made it a memorable experience.
                    </p>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="testimonial-item1 rounded">
                  <div className="author-info mt-2 d-flex align-items-center mb-4">
                    <a href="#">
                      {/* <img
                        src="images/testimonial/visitor2.jpg"
                        alt="Visitor"
                      /> */}
                    </a>
                    <div className="author-title ms-3">
                      <h5 className="m-0 theme">Mr. Rahul Patil</h5>
                      <span>Family Visitor</span>
                    </div>
                  </div>
                  <div className="details">
                    <p className="m-0">
                      <i className="fa fa-quote-left me-2 fs-1"></i>
                      We visited with our kids and they loved the hands-on
                      farming activities. It's a great initiative promoting
                      agro-tourism and reconnecting people with nature.
                    </p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonialsabout;
